import { render, staticRenderFns } from "./Rezeptmanagment.vue?vue&type=template&id=1abac8c4&"
import script from "./Rezeptmanagment.vue?vue&type=script&lang=js&"
export * from "./Rezeptmanagment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports